import React, { useState, useEffect } from "react";
import logo2 from "./logo2.png"
const NAVY = "#0F2444";
const NAVY_DEEP = "#081733";
const RED = "#E63946";
const SLATE = "#33415A";
const MUTED = "#6B7A94";
const ORANGE = "#F07B1D";

export default function App() {
  const [w, setW] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );

  useEffect(() => {
    const onResize = () => setW(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const mobile = w < 640;
  const tablet = w >= 640 && w < 980;

  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        width: "100%",
        overflow: "hidden",
        fontFamily:
          "'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
        background: "#E9EDF3",
      }}
    >
      {/* ---- Mimicked marketplace background (blurred, decorative only) ---- */}
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          filter: "blur(3px)",
          transform: "scale(1.03)",
          zIndex: 0,
        }}
      >
        <MarketplaceBackdrop />
      </div>

      {/* Soft bright wash to lift the blurred backdrop and keep it light */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(160deg, rgba(255,255,255,0.72) 0%, rgba(255,255,255,0.55) 45%, rgba(15,36,68,0.35) 100%)",
          zIndex: 1,
        }}
      />

      {/* ---- Foreground content ---- */}
      <div
        style={{
          position: "relative",
          zIndex: 2,
          minHeight: "100vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: mobile ? "24px 14px" : "40px 20px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 620,
            background: "rgba(255,255,255,0.90)",
            backdropFilter: "blur(14px)",
            WebkitBackdropFilter: "blur(14px)",
            border: "1px solid rgba(15,36,68,0.08)",
            borderRadius: mobile ? 10 : 14,
            boxShadow: "0 24px 60px rgba(8,23,51,0.28)",
            padding: mobile ? "34px 24px" : tablet ? "46px 42px" : "56px 58px",
            boxSizing: "border-box",
            textAlign: "center",
          }}
        >
          {/* Logo */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginBottom: mobile ? 20 : 28,
            }}
          >
            <img
              src={logo2}
              alt="KBM Japan"
              style={{
                width: mobile ? 96 : 116,
                height: "auto",
                marginBottom: 10,
                objectFit: "contain",
              }}
            />
            <div
              style={{
                fontSize: mobile ? 10 : 11,
                fontWeight: 600,
                letterSpacing: 2.5,
                color: MUTED,
                marginTop: 7,
                textTransform: "uppercase",
              }}
            >
              Quality Used Cars, Exported Worldwide
            </div>
          </div>

          {/* Status badge — static, no animation */}
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              background: "#F4F6F9",
              border: "1px solid #DCE3ED",
              color: SLATE,
              fontSize: mobile ? 11 : 12,
              fontWeight: 700,
              letterSpacing: 1,
              textTransform: "uppercase",
              padding: "7px 16px",
              borderRadius: 4,
              marginBottom: mobile ? 18 : 22,
            }}
          >
            <span
              style={{
                width: 7,
                height: 7,
                borderRadius: "50%",
                background: RED,
                display: "inline-block",
              }}
            />
            Site Under Maintenance
          </div>

          {/* Headline */}
          <h1
            style={{
              margin: 0,
              fontSize: mobile ? 22 : tablet ? 28 : 32,
              fontWeight: 800,
              color: NAVY,
              lineHeight: 1.3,
            }}
          >
            KBMjapan.net is currently offline for scheduled updates
          </h1>

          {/* Divider */}
          <div
            style={{
              width: 48,
              height: 3,
              background: RED,
              margin: mobile ? "20px auto" : "26px auto",
              borderRadius: 2,
            }}
          />

          {/* Body copy */}
          <p
            style={{
              margin: "0 auto",
              maxWidth: 460,
              fontSize: mobile ? 14.5 : 16,
              lineHeight: 1.7,
              color: SLATE,
            }}
          >
            Our team is working on improvements to our main website. Stock,
            pricing and customer support continue to operate as normal —
            please contact us directly using the details below and we'll be
            happy to assist.
          </p>

          {/* Divider line */}
          <div
            style={{
              height: 1,
              background: "#E1E7EF",
              margin: mobile ? "24px 0" : "30px 0",
            }}
          />

          {/* Contact block */}
          <div
            style={{
              display: "flex",
              flexDirection: mobile ? "column" : "row",
              gap: mobile ? 12 : 16,
              justifyContent: "center",
            }}
          >
            <a
              href="tel:+81 8033606664"
              style={{
                flex: mobile ? "unset" : 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                textDecoration: "none",
                background: NAVY,
                color: "#FFFFFF",
                fontWeight: 700,
                fontSize: mobile ? 15 : 16,
                padding: mobile ? "13px 16px" : "15px 18px",
                borderRadius: 6,
                boxShadow: "0 8px 18px rgba(15,36,68,0.25)",
                transition: "opacity 0.15s ease",
              }}
            >
              <PhoneIcon color="#FFFFFF" />
              +81 8033606664
            </a>
            <a
              href="tel:23332232232"
              style={{
                flex: mobile ? "unset" : 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                textDecoration: "none",
                background: RED,
                color: "#FFFFFF",
                fontWeight: 700,
                fontSize: mobile ? 15 : 16,
                padding: mobile ? "13px 16px" : "15px 18px",
                borderRadius: 6,
                boxShadow: "0 8px 18px rgba(230,57,70,0.25)",
                transition: "opacity 0.15s ease",
              }}
            >
              <PhoneIcon color="#FFFFFF" />
              +81 8033606664
            </a>
          </div>

          {/* Info site note */}
          <div
            style={{
              marginTop: mobile ? 20 : 24,
              fontSize: mobile ? 12.5 : 13.5,
              color: MUTED,
            }}
          >
            You are viewing our temporary information page at{" "}
            <span style={{ color: NAVY, fontWeight: 700 }}>
              kbmjapan.info
            </span>
            . Full inventory will return to{" "}
            <span style={{ color: RED, fontWeight: 700 }}>kbmjapan.net</span>{" "}
            shortly.
          </div>
        </div>
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------ */
/* Decorative, out-of-focus backdrop built to evoke a used-car         */
/* marketplace listing page (search panel + promo strip + car grid).   */
/* Pure CSS/SVG — no external images, no readable text once blurred.   */
/* ------------------------------------------------------------------ */
function MarketplaceBackdrop() {
  const cards = new Array(14).fill(0);

  return (
    <div style={{ width: "100%", height: "100%", background: "#F3F5F8" }}>
      {/* top nav bar */}
      <div
        style={{
          height: 54,
          background: NAVY_DEEP,
          display: "flex",
          alignItems: "center",
          gap: 18,
          padding: "0 28px",
        }}
      >
        <div
          style={{
            fontSize: 17,
            fontWeight: 800,
            letterSpacing: 2,
            color: "#FFFFFF",
            opacity: 0.9,
            whiteSpace: "nowrap",
          }}
        >
          KBM <span style={{ color: RED }}>JAPAN</span>
        </div>
        <div style={{ flex: 1 }} />
        {new Array(4).fill(0).map((_, i) => (
          <div
            key={i}
            style={{
              width: 60,
              height: 10,
              background: "#FFFFFF",
              opacity: 0.35,
              borderRadius: 2,
            }}
          />
        ))}
      </div>

      {/* sub nav */}
      <div
        style={{
          height: 40,
          background: "#111C33",
          display: "flex",
          alignItems: "center",
          gap: 22,
          padding: "0 28px",
        }}
      >
        {new Array(6).fill(0).map((_, i) => (
          <div
            key={i}
            style={{
              width: 44,
              height: 8,
              background: ORANGE,
              opacity: 0.7,
              borderRadius: 2,
            }}
          />
        ))}
      </div>

      {/* hero row: promo block + search panel */}
      <div
        style={{
          display: "flex",
          gap: 16,
          padding: "20px 28px",
          alignItems: "stretch",
        }}
      >
        <div
          style={{
            width: 190,
            minWidth: 150,
            borderRadius: 4,
            background: `linear-gradient(160deg, ${RED} 0%, #B21E2B 100%)`,
          }}
        />
        <div
          style={{
            flex: 1,
            border: `3px solid ${ORANGE}`,
            borderRadius: 4,
            background: "#FFFFFF",
            padding: 16,
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          <div
            style={{
              width: 160,
              height: 12,
              background: ORANGE,
              opacity: 0.8,
              borderRadius: 2,
            }}
          />
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            {new Array(4).fill(0).map((_, i) => (
              <div
                key={i}
                style={{
                  flex: 1,
                  minWidth: 90,
                  height: 30,
                  background: "#EEF1F5",
                  border: "1px solid #D7DEE8",
                  borderRadius: 3,
                }}
              />
            ))}
            <div
              style={{
                width: 90,
                height: 30,
                background: NAVY_DEEP,
                borderRadius: 3,
              }}
            />
          </div>
        </div>
      </div>

      {/* promo strip */}
      <div style={{ display: "flex", gap: 14, padding: "0 28px 20px" }}>
        {[ORANGE, "#1E9E8C", "#D62839", "#F4B400", "#2B6CB0"].map((c, i) => (
          <div
            key={i}
            style={{
              flex: 1,
              height: 60,
              background: c,
              opacity: 0.85,
              borderRadius: 4,
            }}
          />
        ))}
      </div>

      {/* car grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(7, 1fr)",
          gap: 14,
          padding: "0 28px",
        }}
      >
        {cards.map((_, i) => (
          <div
            key={i}
            style={{
              background: "#FFFFFF",
              border: "1px solid #E3E8EE",
              borderRadius: 4,
              padding: 8,
            }}
          >
            <div
              style={{
                width: "100%",
                paddingTop: "68%",
                background:
                  "linear-gradient(135deg, #C7D0DC 0%, #A9B4C4 100%)",
                borderRadius: 3,
                marginBottom: 8,
              }}
            />
            <div
              style={{
                width: "80%",
                height: 8,
                background: NAVY,
                opacity: 0.5,
                borderRadius: 2,
                marginBottom: 6,
              }}
            />
            <div
              style={{
                width: "55%",
                height: 8,
                background: RED,
                opacity: 0.6,
                borderRadius: 2,
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

function PhoneIcon({ color }) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path
        d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.5.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.4 21 3 13.6 3 4.9c0-.6.4-1 1-1h3.4c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.5.1.4 0 .8-.2 1L6.6 10.8z"
        fill={color}
      />
    </svg>
  );
}